import gql from 'graphql-tag';

const UN_LIKE_POST = gql`
  mutation unLikeChannelPost(
    $postId: String!
    $userId: String!
    $channelId: String!
    $airportId: String!
  ) {
    unLikeChannelPost(
      input: {
        postId: $postId
        userId: $userId
        channelId: $channelId
        airportId: $airportId
      }
    ) {
      airportId
      attachments {
        name
        url
        type
        size
      }
      channelId
      content
      createdAt
      iropsId
      likes
      postId
      updatedAt
      userId
      comments
      isLiked
      user {
        firstName
        lastName
        airportId
        profilePicture
        airportDetails {
          name
          code
          logo
        }
      }
    }
  }
`;

export default UN_LIKE_POST;
